<bp-hl-area-container name="Boden">
	<div class="touch-form">
		<!-- Bodenform Section -->
		<div class="form-section-header">Bodenform</div>

		<!-- HBF-Zeile: Präfix-Platzhalter + HBF-Felder + Suffix -->
		<div class="form-row">
			<div class="form-input-cell multi">
				<div class="prefix-spacer"></div>
				<ng-container *ngFor="let bf of data.header.bodenform.bf; let i = index; trackBy: trackByIndex">
					<wd-list-input *ngIf="i > 0" name="BodenformTrenner" options="/|//" [(model)]="bf.trenner"></wd-list-input>
					<wd-typeahead [(model)]="bf.hbf" label="Hauptbodenform" name="Hauptbodenform[i]" [filter]="hauptbodenformFilter(data.type, i)" placement="bottom"></wd-typeahead>
				</ng-container>
				<div class="btn-group">
					<button *ngIf="data.header.bodenform.bf.length > 1" class="btn btn-danger btn-sm" (click)="removeBodenformPair()"><bi name="trash"></bi></button>
					<button *ngIf="canAddBodenformPair()" class="btn btn-info btn-sm" (click)="addBodenformPair()"><bi name="plus"></bi></button>
				</div>
				<wd-typeahead [(model)]="data.header.bodenform.suffix" label="Suffix" name="BodenformSuffix" placement="bottom"></wd-typeahead>
			</div>
		</div>

		<!-- FBF-Zeile: Präfix (schmal) + FBF-Felder + Buttons + Suffix -->
		<div class="form-row">
			<div class="form-input-cell multi">
				<wd-text-input class="prefix-narrow" [(model)]="data.header.bodenform.prefix" label="Präfix" name="FBFPrefix"></wd-text-input>
				<ng-container *ngFor="let bf of data.header.bodenform.bf; let i = index; trackBy: trackByIndex">
					<wd-list-input *ngIf="i > 0" name="BodenformTrenner" options="/|//" [(model)]="bf.trenner"></wd-list-input>
					<wd-typeahead [(model)]="bf.fbf" label="Feinbodenform" name="Feinbodenform[i]" [filter]="feinbodenformFilter(bf.hbf)" [hbfFilter]="bf.hbf" placement="bottom" (hbfSelected)="bf.hbf = $event" [acceptOtherValues]="true" [otherValuesRegex]="moorFBFRegex" [otherValuesRegexMessage]="moorFBFRegexMessage" [extraSuggestions]="moorFBFSuggestions"></wd-typeahead>
				</ng-container>
				<div class="btn-group">
					<button *ngIf="data.header.bodenform.bf.length > 1" class="btn btn-danger btn-sm" (click)="removeBodenformPair()"><bi name="trash"></bi></button>
					<button *ngIf="canAddBodenformPair()" class="btn btn-info btn-sm" (click)="addBodenformPair()"><bi name="plus"></bi></button>
				</div>
				<wd-typeahead [(model)]="data.header.bodenform.suffix" label="Suffix" name="BodenformSuffix" placement="bottom"></wd-typeahead>
			</div>
		</div>

		<!-- Humusform / Vegetationsformengruppe -->
		<div class="form-row" *ngIf="hatHumusForm(data) || hatVegetationsformengruppe(data)">
			<div class="form-input-cell multi no-scroll">
				<wd-an-typeahead *ngIf="hatHumusForm(data)" name="Humusform" label="Humusform" [(model)]="data.header.humusform.aufnahmeFlaeche"></wd-an-typeahead>
				<wd-typeahead *ngIf="hatVegetationsformengruppe(data)" name="Vegetationsformengruppe" label="Veg.-Gruppe" [(model)]="data.header.vegetationsformengruppe"></wd-typeahead>
			</div>
		</div>

		<!-- Humusauflage Section: alles in einer Zeile -->
		<div class="form-section-header">Humusauflage</div>
		<div class="form-row">
			<div class="form-input-cell multi">
				<wd-number-input name="Ol" label="Ol [cm]" [(model)]="data.extendedHeader.humusAuflage.ol"></wd-number-input>
				<wd-number-input name="Of" label="Of [cm]" [(model)]="data.extendedHeader.humusAuflage.of"></wd-number-input>
				<wd-number-input name="Oh" label="Oh [cm]" [(model)]="data.extendedHeader.humusAuflage.oh"></wd-number-input>
			</div>
		</div>

		<!-- Bodenchemie Section -->
		<div class="form-section-header">Bodenchemie</div>
		<div class="form-row">
			<div class="form-input-cell multi equal-width">
				<wd-list-input name="V-Wert-Vermutet" label="V-Wert geschätzt" [(model)]="data.extendedHeader.vWertSaugsaumVermutet"></wd-list-input>
				<wd-number-input name="V-Wert" label="V-Wert Labor [%]" [(model)]="data.extendedHeader.vWertSaugsaum"></wd-number-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-input-cell multi equal-width">
				<wd-number-input name="pH1" label="pH₁ (H₂O)" [(model)]="data.extendedHeader.ph!.wert1"></wd-number-input>
				<wd-list-input name="PHOrt" label="Ort₁" [(model)]="data.extendedHeader.ph!.ort1"></wd-list-input>
				<span class="inline-label">|</span>
				<wd-number-input name="pH2" label="pH₂ (H₂O)" [(model)]="data.extendedHeader.ph!.wert2"></wd-number-input>
				<wd-list-input name="PHOrt" label="Ort₂" [(model)]="data.extendedHeader.ph!.ort2"></wd-list-input>
			</div>
		</div>

		<!-- Wasserhaushalt Section -->
		<div class="form-section-header">Wasserhaushalt</div>
		<div class="form-row">
			<div class="form-input-cell multi">
				<wd-number-input name="Saugsaum" label="Saugsaum [cm]" [(model)]="data.extendedHeader.saugsaum"></wd-number-input>
				<wd-number-input name="Spiegeltiefe" label="Spiegeltiefe [cm]" [(model)]="data.extendedHeader.spiegelTiefe"></wd-number-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-input-cell multi no-scroll">
				<wd-text-input name="Wasserform2" label="Stauwasserform" [(model)]="data.header.wasserstufe2" [superscript]="true"></wd-text-input>
				<span class="inline-label">/</span>
				<wd-text-input name="Wasserform" label="Grundwasserform" [(model)]="data.header.wasserstufe" [superscript]="true"></wd-text-input>
				<wd-list-input name="Entwässerungsverhalten" label="Entwässerungsverh." [(model)]="data.extendedHeader.entwaesserungsverhalten"></wd-list-input>
			</div>
		</div>

		<!-- Standort Section: STFG komplett in einer Zeile -->
		<div class="form-section-header">Stamm-Standortformengruppe</div>
		<div class="form-row">
			<div class="form-input-cell multi equal-width">
				<wd-typeahead name="Stammfeuchtestufe1" label="Hydromorphiegruppe" [(model)]="data.extendedHeader.stfg.stammFeuchteStufe.first" placement="top"></wd-typeahead>
				<wd-typeahead name="Nährkraftstufe" label="Nährkraft" [(model)]="data.extendedHeader.stfg.naehrkraftStufe" placement="top"></wd-typeahead>
				<wd-typeahead name="Stammfeuchtestufe2" label="Stammfeuchte" [(model)]="data.extendedHeader.stfg.stammFeuchteStufe.second" placement="top"></wd-typeahead>
				<wd-typeahead name="Substratgruppe" label="Substrat" [(model)]="data.extendedHeader.stfg.substratGruppe" placement="top"></wd-typeahead>
				<wd-typeahead [(model)]="data.header.bodenform.suffix" label="Suffix" name="BodenformSuffix" placement="top"></wd-typeahead>
				<wd-list-input name="Mesoklima" label="Mesoklima" [(model)]="data.extendedHeader.mesoklima"></wd-list-input>
				<wd-text-input name="Substratfeuchte" label="Substratfeuchte" [(model)]="data.header.substratFeuchte"></wd-text-input>
				<wd-typeahead name="Klimastufe" label="Klimastufe" [(model)]="data.extendedHeader.klimaStufe.neu" placement="top"></wd-typeahead>
			</div>
		</div>

		<!-- Bemerkungen -->
		<div class="form-section-header">Bemerkungen</div>
		<div class="form-row">
			<div class="form-label-cell">Bemerkungen</div>
			<div class="form-input-cell full-width">
				<wd-multiline-text-input name="Bemerkungen" [(model)]="data.header.bemerkungen"></wd-multiline-text-input>
			</div>
		</div>
	</div>
</bp-hl-area-container>
